const emailHref = ({
  to, subject, body, cc = '',
}) => {
  let link = `mailto:${encodeURIComponent(to)}?`;
  link = `${link}&subject=${encodeURIComponent(subject)}`;
  link = `${link}&body=${encodeURIComponent(body)}`;
  link = `${link}&cc=${encodeURIComponent(cc)}`;

  return link;
};

export default emailHref;
